/**
 * Language Switcher Module
 * Handles dropdown toggle and keyboard navigation
 */

import { trackLanguageSwitch } from './gtm-events.js';

export function initLanguageSwitcher() {
  const switchers = document.querySelectorAll('[data-language-switcher]');

  switchers.forEach(switcher => {
    const trigger = switcher.querySelector('.language-switcher__trigger');
    const dropdown = switcher.querySelector('.language-switcher__dropdown');

    if (!trigger || !dropdown) return;

    let isOpen = false;

    function open() {
      isOpen = true;
      switcher.classList.add('language-switcher--open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      isOpen = false;
      switcher.classList.remove('language-switcher--open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function toggle() {
      if (isOpen) {
        close();
      } else {
        open();
      }
    }

    // Toggle on click
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      toggle();
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!switcher.contains(e.target) && isOpen) {
        close();
      }
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) {
        close();
        trigger.focus();
      }
    });

    // Track language switch on option click
    const options = dropdown.querySelectorAll('.language-switcher__option');
    options.forEach(option => {
      option.addEventListener('click', () => {
        const currentLang = window.location.pathname.startsWith('/ua') ? 'ua' : 'en';
        const targetHref = option.getAttribute('href') || '';
        const targetLang = targetHref.startsWith('/ua') ? 'ua' : 'en';

        if (currentLang !== targetLang) {
          trackLanguageSwitch(currentLang, targetLang);
        }
      });
    });

    // Keyboard navigation in dropdown
    dropdown.addEventListener('keydown', (e) => {
      const options = dropdown.querySelectorAll('.language-switcher__option');
      const currentIndex = Array.from(options).indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % options.length;
        options[nextIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevIndex = (currentIndex - 1 + options.length) % options.length;
        options[prevIndex].focus();
      }
    });
  });
}
